import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const SuspenseFallback = () => (
  <div className="flex justify-center items-center h-screen w-screen fixed inset-0 bg-transparent z-[200]">
    <Loader2 className="w-12 h-12 animate-spin text-primary" />
  </div>
);

const AdminRoute = ({ children }) => {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return <SuspenseFallback />;
  }

  if (!user || profile?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children ? children : <Outlet />;
};

export default AdminRoute;
  